import type { AnyAsyncFn } from './type'

export const once = <T extends AnyAsyncFn>(fn: T): T => {
  let promise: Promise<any> | null = null

  return ((...args) => {
    if (promise) return promise
    promise = fn(...args).finally(() => {
      promise = null
    })
    return promise
  }) as T
}
